import { Layout, Avatar, Button, DropdownMenu } from 'pink-lava-ui';
import { ChevronDownIcon, Menu } from 'lucide-react';
import { useAuth } from '@/context/authContext';
import nabatiLogo from '@/assets/nabati_red_icon.svg';
import { useUIStore } from '@/stores/uiStore';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import HeaderNotification from '@/features/notification/components/HeaderNotification';

const { Header } = Layout;

const CustomHeader = () => {
  const { logout, user } = useAuth();
  const { toggleMobileSidebar } = useUIStore();
  const { isMobile } = useBreakpoint();

  return (
    <div className="bg-white border-l-[1px] border-[#f4f4f4]">
      <Header className="flex h-[56px]! items-center justify-between !bg-white !px-3 gap-3">
        {isMobile && (
          <Button shape="circle" type="ghost" className="!text-gray-700" onClick={toggleMobileSidebar}>
            <Menu size={20} />
          </Button>
        )}
        <div className="flex items-center flex-row gap-1 h-9 overflow-hidden">
          {isMobile && (
            <>
              <img src={nabatiLogo} className="h-7! w-h-7!" alt="nabati logo" />
              DC Trans Vendor
            </>
          )}
        </div>
        <div className="flex items-center gap-3">
          <HeaderNotification />
          <DropdownMenu
            menu={{
              items: [
                {
                  label: `${user?.vendor.code} - ${user?.vendor.name}`,
                  key: 'vendor-id',
                },
                {
                  label: 'Logout',
                  key: 'logout',
                  danger: true,
                  onClick: logout,
                },
              ],
            }}
          >
            <Button
              type="tertiary"
              shape="round"
              icon={
                <div>
                  <ChevronDownIcon size={20} />
                </div>
              }
              iconPosition="end"
              className="!px-1.5 !text-gray-700 !border-gray-200"
            >
              {!isMobile && <div>{user?.name}</div>}
              <Avatar name={user?.name} size={24} className="!bg-pink-200 !text-pink-500 !mb-0.5 !mr-1" />
            </Button>
          </DropdownMenu>
        </div>
      </Header>
    </div>
  );
};

export default CustomHeader;
